// Exclude onboarding on certain paths
export const isNoOnboardingPaths = (path: string): boolean => {
  const onboardingExcludedPaths = [
    '/tools/background-generator/app',
    '/tools/image-generator',
    '/tools/vector-generator',
    '/tools/vectorizer',
    '/pricing',
    '/licensing',
    '/legal',
    '/authorize',
  ];

  return onboardingExcludedPaths.includes(path);
};

export function getKittlBasicsTemplateId() {
  return (
    process.env.NEXT_PUBLIC_KITTL_BASICS_TEMPLATE_ID ||
    'cm1gkql0v00f6ld09s4z553el' // use staging id as default
  );
}
